import { apiService } from "../api.service";
export const resendVerificationMail = async (email: string) => {
  return apiService.apiRequest<any>("post", `auth/resend-verification-email`, {
    email,
  });
};
